import React from "react";
import { makeStyles } from "@material-ui/core";

export const NewReqEditStyle = (props) => {
  const useStyles = makeStyles({
    mt10: {
      marginTop: 10,
    },
    mt20: {
      marginTop: 20,
    },
    mt40: {
      marginTop: 40,
    },
    mt50: {
      marginTop: 50,
    },
    mt80: {
      marginTop: 80,
    },
    ml20: {
      marginLeft: 20,
    },
    mb30: {
      marginBottom: 30,
    },
    mb20: {
      marginBottom: 20,
    },
    textFieldStyles: {
      width: "100%",
      "&:focus": {
        border: "1px solid #476b6b",
      },
    },
    container: {
      width: "900px",
      backgroundColor: "white",
      padding: "30px",
      borderRadius: "6px",
      boxShadow:
        "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
    },
    paper: {
      width: "600px",
    },
    dFlex: {
      display: "flex",
      alignItems: "center",
    },
    dFlow: {
      display: "flex",
      flexDirection: "column",
    },
    avatarStyles: {
      height: 130,
      width: 130,
      //   background: "#09C491",
      cursor: "pointer",
    },
    alignCenter: {
      textAlign: "center",
    },
    fWrap: {
      display: "flex",
      flexWrap: "wrap",
    },
    alignRight: {
      textAlign: "right",
    },
    flexCenter: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  });
  const classes = useStyles();
  return classes;
};
